<template>
	<div v-if="data">
		<template v-if="$platform.setting">
			<template v-if="$platform.setting.display_profit">
				<template v-if="data.profit_value">
					<h5>Margen de beneficio</h5>
					<h4 :class="nameClass">
						<template v-if="data.profit_value">
							{{ data.profit_value | currency }}
						</template>
						<template v-if="data.profit_percent">
							| {{ data.profit_percent }}%
						</template>
					</h4>
				</template>
			</template>
		</template>
	</div>
</template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'data', 'currency'],
		data () {
			return {
				nameClass: null,
			}
		},
		watch: {
			data() {
				this.loadClass()
			},
		},
		mounted() {
			this.loadClass()
		},
		methods: {
			calculateProfit() {
				var purchase_total = 0
				var sale_total = 0
				if(this.data.products) {
					if(this.data.products.length) {
						this.data.products.forEach(function(product) {
							var purchase_price = product.purchase_price
							var base = product.base_price

							var total_measurement_unit_quantity = product.total_measurement_unit
							var quantity = product.quantity
							var save = product.save

							purchase_total = purchase_total + (purchase_price * total_measurement_unit_quantity * quantity)
							sale_total = sale_total + (base * total_measurement_unit_quantity * quantity - save)
						})
					}
				}
				var profit_value = parseFloat(sale_total - purchase_total).toFixed(2)
				if(purchase_total <= 0) {
					var profit_percent = 100
				} else {
					var profit_percent = parseFloat(profit_value * 100 / purchase_total).toFixed(2)
				}

				this.data.profit_value = profit_value
				this.data.profit_percent = profit_percent

				this.loadClass()
			},
			loadClass() {
				if(this.data.profit_value == 0) {
					this.nameClass = 'text-muted'
				} else {
					if(this.data.profit_value < 0) {
						this.nameClass = 'text-danger'
					} else {
						this.nameClass = 'text-success'
					}
				}
			}
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/budgets/views/Profit.vue